/* Blog éditorial — assets/zaydan-blog.js */
(function(){
  'use strict';
  var art=document.querySelector('.zb'); if(!art) return;
  var bar=art.querySelector('[data-zb-progress]');
  function onScroll(){
    var h=document.documentElement, top=h.scrollTop||document.body.scrollTop;
    var height=h.scrollHeight-h.clientHeight;
    if(bar) bar.style.width=(height>0?(top/height*100):0)+'%';
  }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  art.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){var t=document.getElementById(a.getAttribute('href').slice(1));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}});
  });
})();